/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { PatientPortalMessageBoard } from '../model/patientPortalMessageBoard';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';

@Injectable()
export class PatientPortalSendMessageService {

    protected basePath = environment.appSetting.apiUrl + 'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.PatientPortalSendMessage
     * This API Sends message
     * @param messageboard Message box
     * @param practiceCode Set Practice value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patientPortalSendMessage(messageboard: PatientPortalMessageBoard, practiceCode: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public patientPortalSendMessage(messageboard: PatientPortalMessageBoard, practiceCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public patientPortalSendMessage(messageboard: PatientPortalMessageBoard, practiceCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public patientPortalSendMessage(messageboard: PatientPortalMessageBoard, practiceCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        debugger;
        if (messageboard === null || messageboard === undefined) {
            throw new Error('Required parameter messageboard was null or undefined when calling patientPortalSendMessage.');
        }

        if (practiceCode === null || practiceCode === undefined) {
            throw new Error('Required parameter practiceCode was null or undefined when calling patientPortalSendMessage.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (practiceCode !== undefined && practiceCode !== null) {
            queryParameters = queryParameters.set('practiceCode', <any>practiceCode);
        }

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/PatientPortalSendMessage`,
            messageboard,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    
public patientPortalAddOrDeleteAttachmentMessages(fileName: string, activity: string, isReport: boolean, practiceCode: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
public patientPortalAddOrDeleteAttachmentMessages(fileName: string, activity: string, isReport: boolean, practiceCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
public patientPortalAddOrDeleteAttachmentMessages(fileName: string, activity: string, isReport: boolean, practiceCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
public patientPortalAddOrDeleteAttachmentMessages(fileName: string, activity: string, isReport: boolean, practiceCode: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    
    if (fileName === null || fileName === undefined) {
        throw new Error('Required parameter fileName was null or undefined when calling patientPortalAddOrDeleteAttachmentMessages.');
    }

    if (activity === null || activity === undefined) {
        throw new Error('Required parameter activity was null or undefined when calling patientPortalAddOrDeleteAttachmentMessages.');
    }

    if (isReport === null || isReport === undefined) {
        throw new Error('Required parameter isReport was null or undefined when calling patientPortalAddOrDeleteAttachmentMessages.');
    }

    if (practiceCode === null || practiceCode === undefined) {
        throw new Error('Required parameter practiceCode was null or undefined when calling patientPortalAddOrDeleteAttachmentMessages.');
    }

    // Create FormData for multipart/form-data
    const formData = new FormData();
    formData.append('fileName', fileName);
    formData.append('activity', activity);
    formData.append('isReport', isReport.toString());

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (practiceCode !== undefined && practiceCode !== null) {
        queryParameters = queryParameters.set('practiceCode', <any>practiceCode);
    }

    let headers = this.defaultHeaders;

    // authentication (api_key) required
    if (this.configuration.apiKeys["Context"]) {
        headers = headers.set('Context', this.configuration.apiKeys["Context"]);
    }

    // authentication (idp_auth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // Note: Do NOT set Content-Type header for FormData
    // The browser will automatically set it with the correct boundary

    return this.httpClient.post<string>(`${this.basePath}/AddOrDeleteAttachementMessages`,
        formData,
        {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
}

}
